import React from "react";
import PropTypes from "prop-types";
import SpecialityName from "./SpecialityName";
import ViewProviderDetailsGender from "./ViewProviderDetailsGender";
import TeleMedicine from "./TeleMedicine";

const ProviderHeader = ({
  personalDetails,
  educationList,
  specialityList,
  isTelemedicine,
  telemedModalities,
  telemedCaregiverAccess,
  languageData,
}) => {
  const {
    lastName = "",
    firstName = "",
    middleName = "",
    gender = "",
  } = personalDetails;
  return (
    <table
      width={"100%"}
      style={{ marginTop: "2rem" }}
      className="detail-provider-table1"
    >
      <tr style={{ textAlign: "left" }}>
        <td colSpan={2} style={{ textAlign: "left" }}>
          {gender !== "" && (
            <div className="ml-3">
              <>
                <span className="details-heading">
                  {lastName}, {firstName}, {middleName},{" "}
                  {educationList?.education?.[0]?.degree?.degreeCode}
                </span>
              </>
            </div>
          )}
        </td>
      </tr>

      <tr>
        <td colSpan={2} style={{ textAlign: "left" }}>
          <SpecialityName specialityList={specialityList} />
        </td>
      </tr>
      <tr>
        <td colSpan={2} style={{ textAlign: "left" }}>
          {gender && (
            <ViewProviderDetailsGender gender={gender} showLabel={true} />
          )}
        </td>
      </tr>
      <tr>
        <td colSpan={2} style={{ textAlign: "left" }}>
          <TeleMedicine
            isTelemedicine={isTelemedicine}
            telemedModalities={telemedModalities}
            telemedCaregiverAccess={telemedCaregiverAccess}
            languageData={languageData}
          />
        </td>
      </tr>
    </table>
  );
};

ProviderHeader.propTypes = {
  personalDetails: PropTypes.object,
  educationList: PropTypes.object,
  specialityList: PropTypes.object,
  isTelemedicine: PropTypes.boolean,
  telemedModalities: PropTypes.string,
  telemedCaregiverAccess: PropTypes.string,
  languageData: PropTypes.string,
};

export default ProviderHeader;
